import React from "react";
import { Box, styled, Typography, useTheme } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import InterfaceIcon from "@icons/myicons/code.svg?react";
import { SettingsBankConnectionInterface } from "@features/settings/SettingsBankConnections/types";

const ActiveBox = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.dark,
  backgroundColor: theme.palette.background.success,
  borderRadius: "6px",
  padding: theme.spacing(0.5, 2),
  fontSize: "12px",
}));

const ErrorBox = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.dark,
  backgroundColor: theme.palette.background.error,
  borderRadius: "6px",
  padding: theme.spacing(0.5, 2),
}));

const InterfaceRowContainer = styled(Box)(({ theme }) => ({
  borderRadius: "12px",
  border: `1px solid ${theme.palette.border.secondary}`,
  padding: theme.spacing(3, 4.5),
}));

type Props = {
  connectionInterface: SettingsBankConnectionInterface;
};

export const InterfaceRow = ({ connectionInterface }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <InterfaceRowContainer>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Box display="flex" alignItems="center" gap={2}>
            <InterfaceIcon color={theme.palette.secondary.main} />
            <Typography variant="body3">{connectionInterface.name}</Typography>
            {connectionInterface.status === "SUCCESS" && (
              <ActiveBox variant="caption">
                {t("settings.bankConnection.interfaces.active")}
              </ActiveBox>
            )}
            {connectionInterface.status === "FAILED" && (
              <ErrorBox variant="caption">!</ErrorBox>
            )}
          </Box>
          {connectionInterface.lastUpdate && (
            <Typography variant="body3" color="textSecondary" ml={6.75}>
              {t("settings.bankConnection.interfaces.actualized")}{" "}
              {format(
                new Date(connectionInterface.lastUpdate),
                "dd.MM.yyyy, HH:mm"
              )}
            </Typography>
          )}
        </Box>
        {connectionInterface.status === "FAILED" &&
          connectionInterface.error && (
            <Typography variant="body3" color={theme.palette.error.main}>
              {connectionInterface.error}
            </Typography>
          )}
      </Box>
    </InterfaceRowContainer>
  );
};
